import { match } from 'ts-pattern';

import type { Session } from '@/entities/session';

import { formatNessoNote } from './format-nesso-note';
import { formatSoapNote } from './format-soap-note';

export function formatNote(session?: Session): string | null {
    return match(session?.currentNote?.type)
        .with('SOAP', () => formatSoapNote(session))
        .with('NESSO', () => formatNessoNote(session))
        .otherwise(() => null);
}
